export default "__VITE_ASSET__BCyTpg7o__"